import { Injectable, inject } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { DataService } from './data.service';
import { AppStateService } from '../store/state/app/app.state.service';
import { UserClockInRequest, UserClockInResponse } from '../models/UserId';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  #environmentService = inject(EnvironmentService)
  #dataService = inject(DataService)
  #appStateService = inject(AppStateService)


  #checkinUrl = this.#environmentService.getUrl('ng/v1/user/clockinnew/')
  #checkoutUrl = this.#environmentService.getUrl('ng/v1/user/clockout/')
  #clockInTimesUrl = this.#environmentService.getUrl('ng/v1/user/clockintimes/')

  checkin(storeid: number) {
    const sessionId = this.#appStateService.getSession()?.SessionID
    const device = this.#appStateService.getDevice();
    const payload = { Latitude: device.latitude, Longitude: device.longitude, StoreId: storeid };
    const endpoint = this.#checkinUrl + sessionId
    return this.#dataService.post(endpoint, payload);
  }

  checkout() {
    const sessionId = this.#appStateService.getSession()?.SessionID
    const endpoint = this.#checkoutUrl + sessionId
    return this.#dataService.post(endpoint, null);
  }

  clockinTimes(): Observable<UserClockInResponse> {
    const sessionId = this.#appStateService.getSession()?.SessionID
    const endpoint = this.#clockInTimesUrl + sessionId
    const device = this.#appStateService.getDevice();
    const payload: UserClockInRequest = { Latitude: device.latitude, Longitude: device.longitude };
    //const payload: UserClockInRequest = { Latitude: '35.35043753935187', Longitude: '-119.12530446228436' };

    return this.#dataService.post<UserClockInRequest, UserClockInResponse>(endpoint, payload);
  }
}
